import { PMaterial } from "@/commons/interface/speccommon/material";
import { StdResponse, bimAxios } from "@/config/axios";


// 获取库材料列表
export function getSystemMaterials(): Promise<StdResponse<any>> {
    return bimAxios.get(`/materials`);
}

// 获取项目材料列表
export function getMaterialsByprojectUuid(projectUuid: string, majorUuid: string): Promise<StdResponse<any>> {
    return bimAxios.get(`/projects/${projectUuid}/materials`, {
        params: {
            majorUuid: majorUuid
        }
    });
}

// 获取材料详情
export function getMaterialInfo(id: number, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.get(`/materials/${id}`, {
        params: {
            ...params,
        }
    })
}

// 库添加
export function addProjectMaterial(projectUuid: string, materialIds: string[], majorUuid: string, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.post(`/projects/${projectUuid}/materials`, materialIds, {
        params: {
            ...params,
            majorUuid: majorUuid
        }
    })
}

// 删除项目材料
export function deleteProjectMaterial(projectUuid: string, id: string, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.delete(`/projects/${projectUuid}/materials/${id}`, {
        params: {
            ...params,
        }
    })
}

// 保存项目材料
export function addCustomMaterial(projectUuid: string, material: PMaterial, majorUuid: string, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.post(`/projects/${projectUuid}/materials/custom`, material, {
        params: {
            ...params,
            majorUuid: majorUuid
        }
    })
}

// 修改项目材料
export function updateMaterial(id: string, material: PMaterial, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.put(`/materials/${id}`, material, {
        params: {
            ...params,
        }
    })
}

export function deleteProjectMaterialMulti(projectUuid: string, ids: string[], params?: {}): Promise<StdResponse<any>> {
    return bimAxios.post(`/projects/${projectUuid}/materials/delete-multi`, ids, {
        params: {
            ...params,
        }
    })
}

// type: HVAC | STRUCTURE
export function checkMaterialsHasBeenUsed(projectUuid: string, ids: string[], type: string, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.post(`/projects/${projectUuid}/materials/check-used`, ids, {
        params: {
            type: type,
            ...params,
        }
    })
}
